module.exports = __webpack_public_path__ + "static/media/28-7.54331102.mp3";